<template>
  <div class="Repecharge">
    <div class="splitView">
      <div class="preRules">
        <b>复赛比赛说明 - 复赛形式和评分标准</b>
        <br>
        <br>
        <b>复赛时间</b>： 6月15日 10:00-11:30
        <br>
        <br>
        复赛分为两部分，限时闯关与项目设计，复赛最终得分取两个分数的平均数，请合理安排两部分的时间
        <br>
        <br>
        限时闯关以通过关卡数为标准进行评分，关卡数相同时会参考关卡用时以及代码简洁性。
        <br/>
        编程语言请自己从右侧选择，注意完成多个语言的关卡仅取单个语言最高分作为成绩.
        <br/>
        <br/>
        项目设计形式为开放式创意编程算法设计，难度为扣哒世界游戏开发程序设计2 (GD2) 同等水平。
        <br>
        需要选手们自己完成一个可玩的游戏设计。请查看方法栏和提示说明。
        <br />
        评分标准会在程序代码逻辑性和质量，调试可运行性，项目设计和创意，注释可读性等方面做出评判。系统会通过算法对代码质量做评判，人工会对项目设计做出评估。系统也会对代码进行查重，请自己独立完成。
        <br />
        完成代码后，点击开始，确保代码保存，同时需要自己试玩一下游戏，确保没有bug和问题，能够完成游戏目标。
      </div>
      <div class="buttons">
        <div class="left">
        <my_button :value="'限时闯关(Python)'" :inputStyle="buttonStyle" :disable="disable" @click.native="jump('cp')"></my_button>
        <my_button :value="'项目设计(Python)'" :inputStyle="buttonStyle" :disable="disable" @click.native="jump('dp')"></my_button>
</div>
<div class="middle">
</div>
<div class="right">
        <my_button :value="'限时闯关(C++)'" :inputStyle="buttonStyle" :disable="disable" @click.native="jump('cc')"></my_button>
        <my_button :value="'项目设计(C++)'" :inputStyle="buttonStyle" :disable="disable" @click.native="jump('dc')"></my_button>
</div>
      </div>
    </div>
  </div>
</template>

<script>
  // @ is an alias to /src
  import MyImage from '@/components/Image.vue';
  import MyVideo from '@/components/Video.vue';
  import MyButton from '@/components/Button.vue';
  import VueMarkdown from 'vue-markdown'
  import pdfvuer from 'pdfvuer'
  import moment from 'moment'
  export default {
    name: 'repecharge22',
    computed: {
     storeUser() {
       return this.$store.state.auth.user
     },
     game_year() {
       return this.$store.state.game_slug.slice(0, 4)
     },
      passed () {
       if(this.storeUser)
         return this.$store.state.auth.game_state[this.game_year+'-1']?.state > 0
       else
         return false
     },
      faqs () {
        return  [
          {q: '如何才能完成这场附加赛？',
           a:'完成这场附加赛只需要尽可能完成上面的五道题即可，不限顺序，也不要求全部完成。但如果你做完了一道题，一定要记得<b>点击图1中的“提交”按钮</b>，并<b>看到图2 中“概念挑战完成”的弹框</b>，才会被记录得分。同时，<b>完成关卡后请回到当前页面选择下一题</b>，不要在扣哒页面做更多操作。（可以关闭前一题的扣哒页面）',
           imgs: [{src: '/oss/images/plus2021/%E6%8F%90%E7%A4%BA1.png', width: '600px'},{src: '/oss/images/plus2021/%E6%8F%90%E7%A4%BA2.png', width: '800px'}]

          },
          {q: '我如何才能知道我的分数是否被记录上了？',
           a:'我们会自动获取你的通过情况，这个过程需要一些时间，不要着急，每次你回到这个页面大约5秒后你可以看到刚完成的题目变成了绿色的“已完成”，则代表你的成绩已经更新。',
           imgs: [{src: '/oss/images/plus2021/%E6%8F%90%E7%A4%BA3.png', width: '300px'}]},
          {q: '我该如何进入腾讯会议？',
           a:'点击页面上略带紫色的”进入会议“按钮，可以打开会议链接，点击加入会议，然后点击打开腾讯会议，即可加入考试会议。',
           imgs: [{src: '/oss/images/plus2021/%E6%8F%90%E7%A4%BA4.png', width: '300px'},{src: '/oss/images/plus2021/%E6%8F%90%E7%A4%BA5.png', width: '400px'}, {src: '/oss/images/plus2021/%E6%8F%90%E7%A4%BA6.png', width: '800px'}]
          },
          {q: '有哪些考场纪律？',
           a: '1. 监考老师不回答问题。<br>2. 比赛期间，请打开摄像头并静音，需要露出你的脸，确保本人参加，会全程录像。没有摄像头的我们会识别. <br>3. 进入考场后，<b>请修改你的名字为全名。如果不修改，那么附加赛没有你的成绩。</b>'},
          {q: '我的浏览器有问题？',
           a: '推荐使用谷歌浏览器，如果你的浏览器显示有问题，请换<a href="https://www.google.cn/intl/zh-CN/chrome/" >谷歌浏览器</a>。 '},
          {q: '可以提前交卷吗？',
           a:'如果提前做完题目，可以关闭浏览器，离开考场。'},
        ]
      },
      title () {
        return 'https://assets.koudashijie.com/images/magic-rush-bg.jpeg'
      },
      v() {
        return {
          src:'https://assets.koudashijie.com/videos/AI%E4%B8%96%E9%9D%92%E8%B5%9B%E5%A4%8D%E8%B5%9B%E8%A7%86%E9%A2%91%EF%BC%88%E6%97%A0%E7%BD%91%E5%9D%80%EF%BC%89.mp4'
        }
      },
      videoStyle() {
        return {
          width: '40vw',
          'margin-top': 0,
          height: 'auto'
        }
      },
      mdfile() {
        return rulemd
      },
      buttonStyle() {
        return {
          'border-radius': '5px',
          'margin-top': '2vw',
          'width': '8em'
        }
      },
      game_urls () {
        return this.problem_urls.map(u =>
          this.$store.state.loginLink+`&redirect=${encodeURIComponent(u)}&accessToken=${this.$store.state.auth.token.token}`
        )
      },
      mettingNumber() {
        let user = this.user ||  this.$store.state.auth.user
        let url;
        if(user.group == 1) {
          if(user.organization == '斯坦星球') {
            return '979334907'
          }
          else {
            return '137533495'
          }
        }
        else if(user.group == 2) {
          return '241297621'
        }
      },
      /* myClassroom() { */
      /* return this.$store.state.auth.classroom*/
      /* return this.$store.state.classrooms[this.$store.state.auth.classroom[0].classroom_id] */
      /* } */

    },
    data () {
      return {
        disable: true,
        interval: null,
        user: null,
        jumpUrl: '',

        numPages: 0,
        pdfdata: undefined,
        problem_urls: [],
        problem_status: [0, 0, 0, 0, 0],
        courseInstances: {}
      }
    },
    methods: {
      button_titles (index) {
        let origTitles = ['第一题', '第二题', '第三题', '第四题', '第五题']
        return this.problem_status[index] ? '已完成' : origTitles[index]
      }    ,
      getPdf () {
      },

      goto(url) {
        window.open(url, "_blank")
      },
      jump(op) {
        let game;
        let jumpUrl;
        switch(op) {
            case 'dp':
            jumpUrl =this.$store.state.rtlink + 'python'
            break
            case 'dc':
            jumpUrl =this.$store.state.rtlink + 'cpp'
            break
            case 'cp':
            jumpUrl =this.$store.state.cs2link +this.courseInstances.python.cs2
            break
            case 'cc':
            jumpUrl =this.$store.state.cs2link +this.courseInstances['c++'].cs2
            break
        }

       let loginUrl = this.$store.state.gamelink + this.$store.state.auth.token.token
             loginUrl += `&redirect=${encodeURIComponent(jumpUrl)}`
        window.open(loginUrl, '_blank')
      },
      correctTime() {
        return moment(+new Date() + this.$store.state.timeDelay)
      },

    },
    created() {

    },
    mounted() {
      if(!this.passed) {
        console.log('push frontpage')
        this.$router.push({name: 'frontpage'})
      }
      let testTime = moment('2024-06-15 5:00:00')
     let startTime = moment('2024-06-15 10:00:00')
     let timeLimit1 = moment('2024-06-15 10:00:00').subtract(9, 'minutes');
     let timeLimit2 = moment('2024-06-15 10:00:00').subtract(5, 'minutes');
     let endTime = moment('2024-06-15 11:30:00')
     let nowTime = this.correctTime()
      let that = this
     if(nowTime.isBefore(endTime))
       {
         if (nowTime.isBefore(testTime)) {
           alert('你的登录测试已经完成，可以关闭浏览器了')
        this.$router.push({name: 'frontpage'})
           return;
         }
         if(nowTime.isAfter(startTime))
           {
             this.$http.get('/api/me/courses').then(data => {
               this.courseInstances = data.data
               this.disable = false
             })
           }
           that.interval = setInterval(function() {
             if(that.correctTime().isAfter(timeLimit1))
               {
                 clearInterval(that.interval)
                 that.interval = setInterval(function() {

                   if(that.correctTime().isAfter(timeLimit2))
                     {
                       clearInterval(that.interval)
                       that.disable = false
                     }
                 }, 10000)
               }
           }, 60000)
       }

    },
    components: {
      my_image: MyImage,
      my_video: MyVideo,
      my_button: MyButton,
      pdf: pdfvuer,
      vue_markdown: VueMarkdown,
    }
  }
</script>

<style scoped>
  .Repecharge{
    margin-top: 6.5625vw;
    display: flex;
    align-items:center;
    font-size: 1.3vw;
  }
  .splitView{
    margin: auto;
    width: 80%;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
  }

  .buttons{
    width: 80%;
    display: flex;
    justify-content: space-around;
    /* flex-direction: column; */
  }
.middle {
  width: 2px;
  height: 20vh;
    background-color: #6367ff;
}
.left, .right {
  display: flex;
  flex-direction: column;
}
  .passed{
    background-color: #43dd37;
  }
  .meeting {
    background-color: #6367ff;
  }
  .tip{
    color: #F17C67;
    font-weight: 500;
    font-size: 26px;
    margin-top: 20px;
  }
  #rule{
    width: 50vw;
  }
  .split{
    width: 20px;
    height: 5px;
    margin-left: 20px;
  }
  .rules{
    margin-top: 30px;
    width: 80%;
    border: 5px dotted black;
    padding: 20px 40px;
  }
  .faq{
    margin-top: 1em;
    margin-bottom: 1em;
  }
  .faq .q{
    font-weight: bold;
  }
  .faq .q::before{
    content: 'Q: '
  }
  .faq .a::before{
    content: 'A: '
  }
  .faq .img>img {
    margin: 20px 80px;
  }
</style>
